import {MobileOS} from "src/constants/ServiceConstants";


/**
 * Detects the OS based on userAgent set by browser
 */
export const getMobileOS = (): MobileOS => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
        return MobileOS.Android
    } else if ((/iPad|iPhone|iPod/.test(ua)) || navigator.maxTouchPoints > 1) {
        return MobileOS.iOS
    }
    return MobileOS.Unknown
}
